<script>
import Base from "@/components/RequestDetailsForDefaultVue/EstateData.vue";

export default {
  name: "CustomerServiceFilesEstateData",
  extends: Base,
};
</script>
